import { formatEntityName, formatFieldName } from '../../../common';
import { createSchemaStatementHandler } from '../../createSchemaStatementHandler';
export const removeRelationStmtInstruction = `
#### Relationship removal
- Syntax: \`remove relation <owning_entity>.<owning_field>;\`
- Example: \`remove relation Book.genres;\`
`;
export const stmtRemoveRelation = ({ owningEntity, owningField }) => {
    return `remove relation ${owningEntity}.${owningField};`;
};
export const stmtForHumanRemoveRelation = ({ owningEntity, owningField }) => {
    return `Remove the relationship between the database tables __${owningEntity}__ and __${owningField}__.`;
};
export const removeRelationHandler = createSchemaStatementHandler({
    type: 'remove relation',
    parse: line => {
        const match = /^remove relation (?<owningEntityName>\w+)\.(?<owningFieldName>\w+)/.exec(line);
        return match?.groups
            ? {
                type: 'remove relation',
                owningEntity: formatEntityName(match.groups.owningEntityName),
                owningField: formatFieldName(match.groups.owningFieldName),
            }
            : null;
    },
    getHumanStmt: (stmt) => stmtForHumanRemoveRelation(stmt),
    apply: (stmt, builder) => {
        builder.updateSchema(it => it.removeField(stmt.owningEntity, stmt.owningField));
    },
});
//# sourceMappingURL=RemoveRelationStmt.js.map